/**
 * entitlementEnforcementVocabulary — one wording for one deployment fact.
 *
 * `capabilities.tools` is a projection of Tool Registry × `check_entitlement`: what an employee is
 * *entitled* to. Whether that entitlement is *enforced* when an action actually runs is a separate
 * deployment setting (`TOOL_ENTITLEMENT_ENFORCEMENT_ENABLED`, off by default) — with it off,
 * `action_executor` logs the denial and proceeds. Two admin surfaces already disclose that
 * (`AgentsPage`'s readiness chip, `SystemMapLivePage`'s drill-down); the employee-facing screens
 * that present the tool list as this employee's authority import this wording rather than
 * restating the fact in their own words.
 */

export const ENTITLEMENT_ENFORCEMENT_OFF_NOTE =
  "אכיפת זכאות הכלים כבויה כרגע — ההרשאות מוצגות כהצהרה בלבד ואינן נאכפות בזמן ריצה.";

/**
 * The note that must accompany a rendered tool list, or null when none is owed.
 *
 * Two gates, both deliberate:
 *  - No tool list in the payload → nothing is being claimed, so nothing is disclaimed. This keeps
 *    a deriver called without a workspace from printing a caveat about a list it never showed.
 *  - `entitlement_enforced === true` → the list *is* the runtime boundary, and a disclaimer would
 *    be the mirror-image lie. Only an explicit true silences the note: the fact is a safety
 *    disclosure, so a payload that never stated it errs toward disclosing.
 */
export function entitlementBoundaryNote(capabilities) {
  if (!capabilities || !Array.isArray(capabilities.tools)) return null;
  return capabilities.entitlement_enforced === true ? null : ENTITLEMENT_ENFORCEMENT_OFF_NOTE;
}
